'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /* eslint-disable react/no-danger */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _antd = require('@adparlor-devops/antd');

var _reactIntl = require('react-intl');

var _isEmpty = require('lodash/lang/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _reactRouter = require('react-router');

var _selectors = require('../../../store/events/selectors');

var _ActivityTableChild = require('./ActivityTableChild');

var _ActivityTableChild2 = _interopRequireDefault(_ActivityTableChild);

var _constants = require('../../../constants');

require('./ActivityTableParent.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActivityTableParent = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ActivityTableParent, _Component);

  function ActivityTableParent(props) {
    (0, _classCallCheck3.default)(this, ActivityTableParent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ActivityTableParent.__proto__ || (0, _getPrototypeOf2.default)(ActivityTableParent)).call(this, props));

    _this.activityTableChildOnExpand = function (record) {
      var _this$props = _this.props,
          events = _this$props.events,
          filter = _this$props.filter;
      var transactionId = record.transactionId;

      if ((0, _isEmpty2.default)(events[transactionId])) {
        _this.props.createAction('fetchEvents', { transactionId: transactionId, searchTerm: filter.searchTerm });
      }
    };

    _this.viewActivityTableChild = function (record) {
      var events = _this.props.events;
      var transactionId = record.transactionId,
          origin = record.origin;

      var determineParsedEvents = function determineParsedEvents() {
        switch (origin) {
          case _constants.RIPPLE_FACEBOOK_PLATFORM:
            return (0, _selectors.parseEvents)({ events: events[transactionId] });
          case _constants.MONEYTALK_FACEBOOK_PLATFORM:
          case _constants.THUMBSUP_FACEBOOK_PLATFORM:
            return (0, _selectors.parseAutoImportEvents)({ events: events[transactionId] });
          default:
            return [];
        }
      };
      return _react2.default.createElement(_ActivityTableChild2.default, {
        events: determineParsedEvents(),
        origin: origin
      });
    };

    _this.showRuleDescription = function (aggregateEvent) {
      var rules = _this.props.rules;
      var ruleId = aggregateEvent.ruleId;

      if ((0, _isEmpty2.default)(rules[ruleId])) {
        _this.props.createAction('fetchRule', ruleId);
      }
      _this.setState({
        ruleId: ruleId
      });

      _this.toggleDescriptionModal();
    };

    _this.toggleDescriptionModal = function () {
      _this.setState({
        descriptionModalVisible: !_this.state.descriptionModalVisible
      });
    };

    _this.renderDescriptionModal = function () {
      var ruleId = _this.state.ruleId;
      var _this$props2 = _this.props,
          rules = _this$props2.rules,
          ruleErrors = _this$props2.ruleErrors;

      if (ruleErrors.includes(ruleId) || rules[ruleId] && !rules[ruleId].description) {
        return _react2.default.createElement(
          'div',
          { className: 'empty-modal-text' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.ruleDescription.notAvailable.text', defaultMessage: 'Rule not found. It may have been deleted since this event occurred.' })
        );
      }
      if (!rules[ruleId]) return _react2.default.createElement(
        'div',
        { className: 'modal-loading-spinner' },
        _react2.default.createElement(_antd.Spin, null)
      );
      return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: rules[ruleId].description } });
    };

    _this.renderDescriptionModalButtons = function () {
      var ruleId = _this.state.ruleId;
      var rules = _this.props.rules;

      var buttons = [_react2.default.createElement(
        _antd.Button,
        { key: 'close', size: 'large', type: 'primary', onClick: function onClick() {
            return _this.toggleDescriptionModal();
          } },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.ruleDescription.close.button', defaultMessage: 'Close' })
      )];
      if (!rules[ruleId]) return buttons;
      var _rules$ruleId = rules[ruleId],
          rulesetId = _rules$ruleId.rulesetId,
          id = _rules$ruleId.id;

      buttons.unshift(_react2.default.createElement(
        _antd.Button,
        { key: 'goToRule', size: 'large' },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/automation_engine/' + rulesetId + '/builder/' + id, onClick: function onClick() {
              return _this.toggleDescriptionModal();
            } },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.ruleDescription.goToRule.button', defaultMessage: 'Edit Rule' })
        )
      ));
      return buttons;
    };

    _this.renderPaginationButton = function () {
      var _this$props3 = _this.props,
          aggregateEvents = _this$props3.aggregateEvents,
          loadingAggregateEvents = _this$props3.loadingAggregateEvents,
          filter = _this$props3.filter;

      if ((0, _isEmpty2.default)(aggregateEvents) || filter.paginationSize > aggregateEvents.length && !loadingAggregateEvents) return null;
      var onNext = function onNext() {
        var params = (0, _extends3.default)({}, filter, {
          paginationSize: filter.paginationSize + _constants.AGGREGATE_EVENTS_PAGINATION_SIZE
        });
        _this.props.createAction('fetchAggregateEvents', params);
      };
      return _react2.default.createElement(
        'div',
        { className: 'pagination' },
        _react2.default.createElement(
          _antd.Button,
          { type: 'primary', loading: loadingAggregateEvents, onClick: onNext },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.pagination.button.message', defaultMessage: 'Load More' })
        )
      );
    };

    _this.state = {
      descriptionModalVisible: false
    };
    return _this;
  }

  (0, _createClass3.default)(ActivityTableParent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var triggerTooltipMessage = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.table.trigger.column.tooltip', defaultMessage: 'Rules may have been edited since events were logged' });
      var columns = [{
        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.table.aggregateEvent.column', defaultMessage: 'Event' }),
        dataIndex: 'aggregateEvent',
        key: 'aggregateEvent'
      }, {
        title: _react2.default.createElement(
          _antd.Tooltip,
          { title: triggerTooltipMessage, placement: 'right' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.table.trigger.column', defaultMessage: 'Trigger' }),
          _react2.default.createElement(_antd.Icon, { className: 'tooltip-icon', type: 'info-circle-o' })
        ),
        dataIndex: 'trigger',
        key: 'trigger',
        render: function render(text, record) {
          if (record.origin === _constants.RIPPLE_FACEBOOK_PLATFORM) {
            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'a',
                { onClick: function onClick() {
                    return _this2.showRuleDescription(record);
                  } },
                record.trigger
              )
            );
          }
          return _react2.default.createElement(
            'div',
            null,
            record.trigger
          );
        }
      }, {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.table.time.column', defaultMessage: 'Time' }),
        dataIndex: 'timestamp',
        key: 'timestamp',
        width: 200
      }, {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.table.actions.column', defaultMessage: 'Actions' }),
        dataIndex: "actions",
        key: "actions",
        width: 90,
        className: "action-icons",
        render: function render(text, record) {
          var arReportUrl = record.arReportUrl;

          var arIconType = "export";

          if (arReportUrl) {
            return _react2.default.createElement(
              'a',
              { href: arReportUrl },
              _react2.default.createElement(
                _antd.Tooltip,
                { getPopupContainer: function getPopupContainer() {
                    return document.getElementsByClassName('action-icons')[0];
                  }, title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.table.actions.column.arLink', defaultMessage: 'View in AR' }) },
                _react2.default.createElement(_antd.Icon, { type: arIconType })
              )
            );
          }

          return _react2.default.createElement(
            _antd.Tooltip,
            { title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.table.actions.column.noARLink', defaultMessage: 'Link Not Available' }) },
            _react2.default.createElement(
              'span',
              { className: 'disable-cursor' },
              _react2.default.createElement(
                'a',
                { disabled: true },
                _react2.default.createElement(_antd.Icon, { type: arIconType })
              )
            )
          );
        }
      }];

      var _props = this.props,
          loadingAggregateEvents = _props.loadingAggregateEvents,
          aggregateEvents = _props.aggregateEvents;


      return _react2.default.createElement(
        'div',
        { className: 'ActivityTableParent__Component' },
        _react2.default.createElement(_antd.Table, {
          rowKey: 'key',
          size: 'middle',
          bordered: true,
          loading: loadingAggregateEvents,
          columns: columns,
          dataSource: aggregateEvents,
          expandedRowRender: function expandedRowRender(record) {
            return _this2.viewActivityTableChild(record);
          },
          onExpand: function onExpand(expanded, record) {
            return _this2.activityTableChildOnExpand(record);
          },
          pagination: false
        }),
        _react2.default.createElement(
          _antd.Modal,
          {
            title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ActivityTableParent.ruleDescription.title', defaultMessage: 'Rule Description' }),
            visible: this.state.descriptionModalVisible,
            width: 800,
            onCancel: function onCancel() {
              return _this2.toggleDescriptionModal();
            },
            footer: this.renderDescriptionModalButtons()
          },
          this.renderDescriptionModal()
        ),
        this.renderPaginationButton()
      );
    }
  }]);
  return ActivityTableParent;
}(_react.Component), _class.propTypes = {
  createAction: _propTypes2.default.func.isRequired,
  loadingAggregateEvents: _propTypes2.default.bool.isRequired,
  aggregateEvents: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  rules: _propTypes2.default.objectOf(_propTypes2.default.object).isRequired,
  ruleErrors: _propTypes2.default.arrayOf(_propTypes2.default.string),
  events: _propTypes2.default.objectOf(_propTypes2.default.array).isRequired,
  filter: _propTypes2.default.shape({
    paginationSize: _propTypes2.default.number
  }).isRequired
}, _class.defaultProps = {
  ruleErrors: []
}, _temp);
exports.default = ActivityTableParent;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/dear-diary/lib/modules/ActivityTable/components/ActivityTableParent.js
// module id = 3419
// module chunks = 2